'use client';

import { Group, Text, createStyles } from '@mantine/core';

import QuestionMarkTooltip from './QuestionMarkTooltip';
import { ReactNode } from 'react';
import { isDark } from '@/utils/utils';
import themeVariables from '@/styles/themeVariables';

const usePageHeaderStyles = createStyles((theme, dark: any) => ({
  titleBarOuter: {
    display: 'flex',
    alignItems: 'center',
    color: theme.colors.gray[8],
    marginBottom: 40,
    [theme.fn.smallerThan('sm')]: {
      flexDirection: 'column',
      gap: 10,
      marginBottom: 30,
    },
  },

  title: {
    fontWeight: 700,
    fontSize: 21,
    display: 'inline-block',
    color: dark?.dark
      ? themeVariables.label.normalDark
      : themeVariables.label.normal,
  },

  rightElementsContainer: {
    [theme.fn.largerThan('sm')]: {
      marginLeft: 'auto',
    },
  },
}));

type Props = {
  title: string;
  tooltipContent?: string;
  leftElements?: ReactNode;
  rightElements?: ReactNode;
};

const PageHeader = ({
  title,
  tooltipContent = '',
  leftElements,
  rightElements,
}: Props) => {
  const { dark } = isDark();
  const { classes } = usePageHeaderStyles({ dark });

  return (
    <div className={classes.titleBarOuter}>
      {title && (
        <Group spacing={6}>
          <Text className={classes.title}>{title}</Text>
          {tooltipContent && <QuestionMarkTooltip label={tooltipContent} />}
        </Group>
      )}
      {leftElements && <div>{leftElements}</div>}
      {rightElements && (
        <div className={classes.rightElementsContainer}>{rightElements}</div>
      )}
    </div>
  );
};

export default PageHeader;
